import { GlobalSnackbarQueryMutationResolver } from '@deltek/specification-client/core/Configurations/GlobalSnackbar'
import { CurrentUserInfoQueryMutationResolver } from '@deltek/specification-client/core/GraphQL/Resolvers/currentUserInfo.resolvers'
import { BannerInfoResolver } from './bannerInfo.resolvers'
import { CategoriesResolver } from './category.resolvers'
import { FavoriteContactsResolver } from './contact.resolvers'
import { ListingCountResolver } from './listing.resolvers'
import { AllProductsResolver } from './product.resolvers'
import { ProductSearchResolver } from './productSearch.resolvers'
import { GetAllUsersQueryResolver } from './user.resolvers'

const resolvers = {
    Query: {
        ...AllProductsResolver,
        ...BannerInfoResolver,
        ...CategoriesResolver,
        ...FavoriteContactsResolver,
        ...ListingCountResolver,
        ...ProductSearchResolver,
        ...GetAllUsersQueryResolver,
    },
    Mutation: {
        ...CurrentUserInfoQueryMutationResolver.Mutation,
        ...GlobalSnackbarQueryMutationResolver.Mutation,
    },
}

export default resolvers
